<template>
  <container-item-wrapper :widget="widget">

    <div :key="widget.id" class="tab-container"
         v-show="!widget.options.hidden">
      <el-tabs v-model="activeTabName" :type="widget.displayType" :ref="widget.id" :class="[customClass]" @tab-click="onTabClick">
        <el-tab-pane v-for="(tab, index) in visibleTabs" :key="index" :label="tab.options.label"
                     :disabled="tab.options.disabled" :name="tab.options.name">
          <template v-for="(subWidget, swIdx) in tab.widgetList">
            <template v-if="'container' === subWidget.category">
              <component :is="getComponentByContainer(subWidget)" :widget="subWidget" :key="swIdx" :parent-list="tab.widgetList"
                              :index-of-parent-list="swIdx" :parent-widget="widget"
                              :sub-form-row-id="subFormRowId" :sub-form-row-index="subFormRowIndex" :sub-form-col-index="subFormColIndex">
                <!-- 递归传递插槽！！！ -->
                <template v-for="slot in Object.keys($scopedSlots)" v-slot:[slot]="scope">
                  <slot :name="slot" v-bind="scope"/>
                </template>
              </component>
            </template>
            <template v-else>
              <component :is="subWidget.type + '-widget'" :field="subWidget" :key="swIdx" :parent-list="tab.widgetList"
                            :index-of-parent-list="swIdx" :parent-widget="widget"
                            :sub-form-row-id="subFormRowId" :sub-form-row-index="subFormRowIndex" :sub-form-col-index="subFormColIndex">
                <!-- 递归传递插槽！！！ -->
                <template v-for="slot in Object.keys($scopedSlots)" v-slot:[slot]="scope">
                  <slot :name="slot" v-bind="scope"/>
                </template>
              </component>
            </template>
          </template>
        </el-tab-pane>
      </el-tabs>
    </div>

  </container-item-wrapper>
</template>

<script>
  import emitter from '@/utils/emitter'
  import i18n from "../../../utils/i18n"
  import refMixin from "../../../components/form-render/refMixin"
  import ContainerItemWrapper from './container-item-wrapper'
  import containerItemMixin from "./containerItemMixin";
  import FieldComponents from '@/components/form-designer/form-widget/field-widget/index'

  export default {
    name: "tab-item",
    componentName: 'ContainerItem',
    mixins: [emitter, i18n, refMixin, containerItemMixin],
    components: {
      ContainerItemWrapper,
      ...FieldComponents,
    },
    props: {
      widget: Object,

      subFormRowIndex: { /* 子表单组件行索引，从0开始计数 */
        type: Number,
        default: -1
      },
      subFormColIndex: { /* 子表单组件列索引，从0开始计数 */
        type: Number,
        default: -1
      },
      subFormRowId: { /* 子表单组件行Id，唯一id且不可变 */
        type: String,
        default: ''
      },

    },
    inject: ['refList', 'sfRefList', 'globalModel'],
    data() {
      return {
        activeTabName: '',
      }
    },
    computed: {
      visibleTabs() {
        return this.widget.tabs.filter(tp => {
          return !tp.options.hidden
        })
      },

    },
    created() {
      this.initRefList()
    },
    mounted() {
      this.initActiveTab()
    },
    beforeDestroy() {
      this.unregisterFromRefList()
    },
    methods: {
    onTabClick(evt) {
      // console.log("onTabClick", evt);
      let paneName = evt.name;
      this.widget.tabs.forEach((tp) => {
        tp.options.active = tp.options.name === paneName;
      });
      let tmpFunc = new Function("val", this.widget.options.onClick);
      return tmpFunc.call(this, evt.index);
    },
    /**
     * 获取当前激活的页签索引，从0开始计数
     * @return {number}
     */
    getActiveTabIndex() {
      let foundIndex = -1
      this.widget.tabs.forEach((tp, idx) => {
        if (tp.options.name === this.activeTabName) {
          foundIndex = idx
        }
      })

      return foundIndex
    },
    initActiveTab() {
      if ((this.widget.type === 'tab') && (this.widget.tabs.length > 0)) {
        let activePanes = this.widget.tabs.filter((tp) => {
          return tp.options.active === true
        })
        if (activePanes.length > 0) {
          this.activeTabName = activePanes[0].options.name
        } else {
          this.activeTabName = this.widget.tabs[0].options.name
        }
      }
    },

    },
  }
</script>

<style lang="scss" scoped>

.tab-container {
    margin: 0px;
    .form-widget-list {
      min-height: 28px;
    }
  }

  ::v-deep .el-tabs--border-card{
    border: none;
    box-shadow:none;
  }

  .tab-container.selected {
    outline: 2px solid $--color-primary !important;
  }
  ::v-deep .el-tabs__item{
    height: 29px;
    line-height: 29px;
  }


::v-deep .el-tabs--border-card>.el-tabs__header {
    background-color: #fff;
    border-bottom: 1px solid var(--main-color);
    margin: 0;
}

::v-deep .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
    color: var(--main-color);
    border-right-color: var(--main-color);
    border-left-color: var(--main-color);
    border-top: 1px solid var(--main-color);
    margin-top: 1px;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    font-weight: bold;
    margin-left: 0px;
}
::v-deep .el-tabs--border-card>.el-tabs__header .el-tabs__item+.el-tabs__item, .el-tabs--border-card>.el-tabs__header .el-tabs__item:first-child{
  margin-left: 0;
}
::v-deep .el-tabs--border-card > .el-tabs__header{
  padding-left: 5px;
  box-sizing: border-box;
}

::v-deep .el-tabs--border-card>.el-tabs__header .el-tabs__item{
  color: #3b3b3b;
}
</style>
